export interface User {
  id: string;
  phone: string;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  emailVerified?: boolean;
  phoneVerified?: boolean;
  countryCode?: string;
  countryIso?: string;
  requiresPassword?: number;
  isPlantExists: boolean;
  androidVersion: string;
  appVersion: string;
  mobileMake: string;
  mobileModel: string;
  isBMSPlantExists: boolean;
  active: boolean;
  onboardingCompleted?: boolean;
  onboardingCompletedAt?: number;
  profileComplete?: boolean;
  completionPercentage?: number;
  locale?: string;
  dateOfBirth?: number;
  company?: string;
  jobTitle?: string;
  fullAddress?: string;
  secondryRoles: number[];
  primary_role: string;
  user_type: UserType;
  secondary_roles: number[];
  installer_id: string;
  user_image: string;
  userCategory: UserCategory;
}
export enum UserType {
  CUSTOMER = 1,
  ADMIN = 2,
  SYSTEM_INTEGRATOR = 3,
  SECONDARY_USER = 4,
  THIRD_PARTY_INTEGRATOR = 6,
  LARGE_SCALE=90,
  WEB_DYN=80
}

export enum UserCategory {
    FREE = 0,
    STANDARD = 1,
    PREMIUM = 2,
    ELITE = 3,
  }
